export default __webpack_public_path__ + "static/media/info-model.8518143b.webp";